type BreadcrumbMatcher = {
  pattern: RegExp;
  handler: (matches: RegExpMatchArray) => { currentLabel: string; parentLabel?: string, grandParentLabel?: string };
};

class BreadcrumbFactory {
  private matchers: BreadcrumbMatcher[] = [];

  register(pattern: RegExp, handler: BreadcrumbMatcher['handler']) {
    this.matchers.push({ pattern, handler });
    return this;
  }

  getLabels(pathname: string) {
    for (const { pattern, handler } of this.matchers) {
      const matches = pathname.match(pattern);
      if (matches) {
        return handler(matches);
      }
    }
    return null;
  }
}

// 싱글톤 인스턴스 생성 및 규칙 등록
export const breadcrumbFactory = new BreadcrumbFactory()
  // 상품 - 피스
  .register(
    /^\/products\/pieces$/,
    () => ({ currentLabel: '피스 목록', parentLabel: '디자인' })
  )
  .register(
    /^\/products\/pieces\/(create)$/,
    () => ({ currentLabel: '피스 등록', parentLabel: '피스', grandParentLabel: '디자인' })
  )
  .register(
    /^\/products\/pieces\/(\d+)\/edit$/,
    () => ({ currentLabel: '피스 수정', parentLabel: '피스', grandParentLabel: '디자인' })
  )
  // 상품 - 세트
  .register(
    /^\/products\/set$/,
    () => ({ currentLabel: '세트 목록', parentLabel: '디자인' })
  )
  .register(
    /^\/products\/set\/(create)$/,
    () => ({ currentLabel: '세트 등록', parentLabel: '세트', grandParentLabel: '디자인' })
  )
  .register(
    /^\/products\/set\/(\d+)\/edit$/,
    () => ({ currentLabel: '세트 수정', parentLabel: '세트', grandParentLabel: '디자인' })
  )
  // 액세서리 - 파츠
  .register(
    /^\/accessory\/parts$/,
    () => ({ currentLabel: '파츠 목록', parentLabel: '액세서리' })
  )
  .register(
    /^\/accessory\/parts\/(create)$/,
    () => ({ currentLabel: '파츠 등록', parentLabel: '파츠', grandParentLabel: '액세서리' })
  )
  .register(
    /^\/accessory\/parts\/(\d+)\/edit$/,
    () => ({ currentLabel: '파츠 수정', parentLabel: '파츠', grandParentLabel: '액세서리' })
  )
  // 액세서리 - 부자재
  .register(
    /^\/accessory\/consumables$/,
    () => ({ currentLabel: '부자재 목록', parentLabel: '액세서리' })
  )
  .register(
    /^\/accessory\/consumables\/(create)$/,
    () => ({ currentLabel: '부자재 등록', parentLabel: '부자재', grandParentLabel: '액세서리' })
  )
  .register(
    /^\/accessory\/consumables\/(\d+)\/edit$/,
    () => ({ currentLabel: '부자재 수정', parentLabel: '부자재', grandParentLabel: '액세서리' })
  )
  // 액세서리 - 비매품
  .register(
    /^\/accessory\/non-sales$/,
    () => ({ currentLabel: '비매품 목록', parentLabel: '액세서리' })
  )
  // 고객
  .register(
    /^\/customer$/,
    () => ({ currentLabel: '고객 목록', parentLabel: '고객' })
  )
  .register(
    /^\/customer\/(\d+)\/detail$/,
    () => ({ currentLabel: '고객 상세', parentLabel: '고객' })
  )
  // 주문
  .register(
    /^\/order$/,
    () => ({ currentLabel: '주문 내역', parentLabel: '주문' })
  )
  .register(
    /^\/order\/(\d+)\/detail$/,
    () => ({ currentLabel: '주문 상세', parentLabel: '주문' })
  )
  // 결제
  .register(
    /^\/payment$/,
    () => ({ currentLabel: '결제', parentLabel: '결제내역' })
  )
  // 매장
  .register(
    /^\/store$/,
    () => ({ currentLabel: '매장 목록', parentLabel: '매장' })
  )
  .register(
    /^\/store\/(\d+)\/detail$/,
    () => ({ currentLabel: '매장 상세', parentLabel: '매장' })
  )
  .register(
    /^\/store\/(create)$/,
    () => ({ currentLabel: '매장 등록', parentLabel: '매장' })
  )
  .register(
    /^\/store\/(\d+)\/edit$/,
    () => ({ currentLabel: '매장 수정', parentLabel: '매장' })
  )
  // 장비 - 자판기
  .register(
    /^\/equipment\/vending-machine$/,
    () => ({ currentLabel: '자판기 목록', parentLabel: '장비' })
  )
  .register(
    /^\/equipment\/vending-machine\/(create)$/,
    () => ({ currentLabel: '자판기 등록', parentLabel: '자판기', grandParentLabel: '장비' })
  )
  .register(
    /^\/equipment\/vending-machine\/(\d+)\/edit$/,
    () => ({ currentLabel: '자판기 수정', parentLabel: '자판기', grandParentLabel: '장비' })
  )
  .register(
    /^\/equipment\/vending-machine\/(\d+)\/detail$/,
    () => ({ currentLabel: '자판기 상세', parentLabel: '자판기', grandParentLabel: '장비' })
  )
  // 기획전
  .register(
    /^\/special-exhibition$/,
    () => ({ currentLabel: '기획전', parentLabel: '기획전 내역' })
  )
  .register(
    /^\/special-exhibition\/(create)$/,
    () => ({ currentLabel: '기획전 등록', parentLabel: '기획전', grandParentLabel: '기획전' })
  )
  .register(
    /^\/special-exhibition\/(\d+)\/edit$/,
    () => ({ currentLabel: '기획전 수정', parentLabel: '기획전', grandParentLabel: '기획전' })
  )